<template>
  <div class="wizard">
    <component
      v-if="!done"
      :is="currentStep"
      ref="step"
      :context="stepContext"
      @back="back"
      @done="next"
    />
    <congrats v-if="done" />
    <v-overlay v-if="processing">
      <v-progress-circular color="primary" indeterminate />
    </v-overlay>
  </div>
</template>

<script>
import BusinessDetailsStep from "./steps/BusinessDetailsStep";
import LoyaltyCoreEarnStep from "./steps/LoyaltyCoreStepEarn";
import LoyaltyCoreGiftStep from "./steps/LoyaltyCoreStepGift";
import LoyaltyPromotionStep from "./steps/LoyaltyPromotionStep";
import CustomerPortalStep from "./steps/CustomerPortalStep";
import LegalStep from "./steps/LegalStep";
import GoLiveStep from "./steps/GoLiveStep";
import Congrats from "./Congrats";
import htmlToCanvas from "html2canvas";
import axios from "axios";
import uuid from "uuid";

export default {
  components: {
    BusinessDetailsStep,
    LoyaltyCoreEarnStep,
    LegalStep,
    LoyaltyCoreGiftStep,
    LoyaltyPromotionStep,
    CustomerPortalStep,
    GoLiveStep,
    Congrats
  },
  data() {
    return {
      steps: ["BusinessDetailsStep", "LoyaltyCoreEarnStep", "LoyaltyCoreGiftStep", "LoyaltyPromotionStep", "CustomerPortalStep", "GoLiveStep"],
      currentStepIndex: 1,
      data: {},
      done: false,
      processing: false
    };
  },
  created() {
    this.id = uuid();
    this.$ga.page("Wizard Step #1");
  },
  watch: {
    currentStepIndex(currentStepIndex) {
      this.$ga.page(`Wizard Step #${currentStepIndex}`);
    },
    done(done) {
      done && this.$ga.page("Wizard Congratulations");
    }
  },
  computed: {
    currentStep() {
      return this.steps[this.currentStepIndex - 1];
    },
    stepContext() {
      return {
        currentStep: this.currentStepIndex,
        totalSteps: this.steps.length,
        firstStep: this.currentStepIndex === 1,
        lastStep: this.currentStepIndex === this.steps.length,
        submittedData: this.data[this.currentStepIndex],
        allData: this.data
      };
    }
  },
  methods: {
    back() {
      if (!this.stepContext.firstStep) this.currentStepIndex--;
      else this.$router.replace("/");
    },
    async next(data) {
      this.handleDynamicSteps(data);
      this.data[this.currentStepIndex] = data;
      // Send step data to server in background
      this.sendStepData();
      // Send step snanshot to server in background (and ignore failures)
      this.sendStepSnapshot();

      if (this.stepContext.lastStep) {
        this.processing = true;
        // Submit form and wait for ack
        await this.submitForm();
        this.processing = false;
        this.done = true;
      } else this.currentStepIndex++;
    },
    sendStepData() {
      return axios.post(
        `/api/wizard/${this.id}/step/${this.currentStepIndex}/data`,
        this.data[this.currentStepIndex]
      );
    },
    sendStepSnapshot() {
      const stepIndex = this.currentStepIndex;
      return htmlToCanvas(document.getElementsByClassName('form-pane')[0], { logging: false }
     //      {
     //         height: window.innerHeight,
     // windowHeight: window.innerHeight,
     // scrollY: -window.scrollY,
     //   logging: false }
      )
        .then(canvas =>
          axios.post(`/api/wizard/${this.id}/step/${stepIndex}/snapshot`, {
            file: canvas.toDataURL()
          })
        )
        .catch((e) => {
          console.log(e);
        });
    },
    submitForm() {
      return axios.post(`/api/wizard/${this.id}/submit`, this.data);
    },
    handleDynamicSteps(data) {
      if(data && data.existingLoyaltyProgram){
        if(data.existingLoyaltyProgram ==='revel' && !this.steps.includes('LegalStep')){
          this.steps.splice(this.steps.length -1, 0, "LegalStep");
        }
        else if(data.existingLoyaltyProgram !=='revel' && this.steps.includes('LegalStep')){
          this.steps.splice(this.steps.indexOf('LegalStep'), 1);
        }
      }
    }
  }
};
</script>

<style scoped>
.wizard {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
